import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons:
  {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#ff9933',
        secondary: '#006699',
        accent: '#ffcc66'
      }
    }
  }

})
